// File: z__jsCollectionsLanding.js
// NOTE: This script defines the Alpine component used on the collections landing page
// and exposes a couple of global smooth-scroll helpers in the LUC namespace.

import Slider from "../utilities/Helpers/UI/Slider";
import { getHeaderScrollOffset } from "../utilities/Helpers/helpers";

// Ensure global namespace exists
window.LUC = window.LUC || {};

LUC.jsCollectionsLanding = {
    alpine: true,
    showSticky: false,
    onTop: true,
    ignoreScroll: false,
    lastScrollY: 0,
    scrollTimeout: null,
    scrollCheckInterval: null,

    init() {
        this.initializeSliders();
        this.changeLayout();
    },

    handleScroll() {
        this.onTop = window.scrollY <= (window.innerWidth > 1024 ? 117 : 94);
        clearTimeout(this.scrollTimeout);
        this.toggleStickyState();
        this.startScrollPositionCheck();
        this.scrollTimeout = setTimeout(() => {
            this.confirmScrollEnd();
        }, 200);
    },

    startScrollPositionCheck() {
        if (this.scrollCheckInterval) return;

        this.lastScrollCheck = window.scrollY;
        this.scrollCheckInterval = setInterval(() => {
            if (window.scrollY === this.lastScrollCheck) {
                this.confirmScrollEnd();
            } else {
                this.lastScrollCheck = window.scrollY;
            }
        }, 50);
    },

    confirmScrollEnd() {
        clearInterval(this.scrollCheckInterval);
        this.scrollCheckInterval = null;
        this.ignoreScroll = false;
    },

    initializeSliders() {
        this.initializeSlider(this.$refs?.sliderStatic);
        this.initializeSlider(this.$refs?.sliderSticky);
    },

    initializeSlider(slider) {
        if (slider) {
            const customConfig = {
                slidesPerView: 3,
                loop: false,
                cssMode: true,
                breakpoints: {
                    768: {
                        slidesPerView: "auto",
                        spaceBetween: 0,
                    },
                },
            };
            new Slider(slider, customConfig);
        }
    },

    toggleStickyState() {
        if (!this.ignoreScroll) {
            const currentScrollY = window.scrollY;
            this.showSticky = currentScrollY >= 50 && currentScrollY < this.lastScrollY;
            this.lastScrollY = currentScrollY;
        }
    },

    scrollToSection(event) {
        event.preventDefault();
        this.ignoreScroll = true;
        const targetId = event.target.closest("a").getAttribute("href");
        const targetElement = document.querySelector(targetId);

        if (targetElement) {
            let headerOffset;
            if (this.showSticky) {
                headerOffset = window.innerWidth >= 1024 ? 240 : 200; // Different offset for sticky
            } else {
                headerOffset = getHeaderScrollOffset();
            }
            const elementPosition = targetElement.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.scrollY - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
            });
        }
    },

    changeLayout: function () {
        const gridContainers = document.querySelectorAll("[data-grid-layout]");
        gridContainers.forEach((gridContainer) => {
            if (window.matchMedia("(min-width: 1580px)").matches) {
                gridContainer.dataset.gridLayout = "medium";
            } else {
                gridContainer.dataset.gridLayout = "half";
            }
        });
    },
};
